import { withSubComponents } from '@/utils/react';
import NavigationContextMenuItem from './NavigationContextMenuItem';
import NavigationContextMenu from './NavigationContextMenu';
import NavigationContextMenuSeparator from './NavigationContextMenuSeparator';
import NavigationContextMenuInternalLinkItem from './NavigationContextMenuInternalLinkItem';
import NavigationContextMenuButton from './NavigationContextMenuButton';
import NavigationContextMenuExternalLinkItem from './NavigationContextMenuExternalLinkItem';

export type { NavigationContextMenuProps } from './NavigationContextMenu';
export { default as NavigationContextMenuContext } from './NavigationContextMenuContext';

export default withSubComponents(NavigationContextMenu, {
    Item: NavigationContextMenuItem,
    InternalLink: NavigationContextMenuInternalLinkItem,
    ExternalLink: NavigationContextMenuExternalLinkItem,
    Separator: NavigationContextMenuSeparator,
    Button: NavigationContextMenuButton,
});